import { render, staticRenderFns } from "./voiceAdvice.vue?vue&type=template&id=55c87897&scoped=true"
import script from "./voiceAdvice.vue?vue&type=script&lang=js"
export * from "./voiceAdvice.vue?vue&type=script&lang=js"
import style0 from "./voiceAdvice.vue?vue&type=style&index=0&id=55c87897&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c87897",
  null
  
)

export default component.exports